<template>
  <DetailOurTeam class="h-full overflow-y-hidden" :listCategory="listCategory"/>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import DetailOurTeam from '@/components/ComponentOurTeam/DetailOurTeam.vue';
import ScrollToTop from '@/components/ScrollToTop.vue';
import axios from 'axios';

export default {
  data(){
    return{
      whitetheme: true,
      listCategory: []
    }
  },
  components:{
    Navbar,
    DetailOurTeam,
    ScrollToTop,
  },
  created(){
    axios.get(`team`)
    .then(res => {
      this.listCategory = res.data;
    }).catch(err => {
      console.log(err.message);
    })
  },
  methods:{
    scrollup(){
        window.scroll({
            top: 0,
            left: 0,
        })
    },
  },
  mounted(){
      this.scrollup()
  }
}
</script>

<style scoped>
html { height: 100%; overflow:auto; }
body { height: 100%; }
</style>